import { Component, OnInit, HostListener,PLATFORM_ID,Inject } from '@angular/core';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-beijing-institute',
  templateUrl: './beijing-institute.component.html',
  styleUrls: ['./beijing-institute.component.scss']
})
export class BeijingInstituteComponent implements OnInit {

  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  formSection: boolean = true;
  thankSection: boolean = false;
  @HostListener('input') oninput() {
    if (this.contactForm.valid) {
      this.disabledSubmitButton = false;
    }
  }

  constructor(
    private fb: FormBuilder,
    private networkCall: WebsiteService,
    private toastr: ToastrService,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
     private router: Router
    // private shareService: SharedService

  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactFormProductName': ['Trinka AI', Validators.required],
      'contactFormQueryType': ['', Validators.required],
      'contactFormMessage': ['', Validators.required],
      'agreeTerms': [false, Validators.requiredTrue]
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Beijing Institute Of Petrochemical Technology | Helpdesk');
    this.metaTagService.updateTag({ name: 'description', content: "Beijing Institute Of Petrochemical Technology | Helpdesk" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Beijing Institute Of Petrochemical Technology | Helpdesk' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Beijing Institute Of Petrochemical Technology | Helpdesk' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/beijing-institute-petrochemical-technology-helpdesk' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/beijing-institute-petrochemical-technology-helpdesk' });

  }

  processForm() {
    // console.log("gggg")
    // if(this.contactForm.value.contactFormEmail && this.contactForm.value.contactFormName && this.contactForm.value.contactFormSubjects && this.contactForm.value.contactFormMessage){
    if (this.contactForm.valid) {
      // console.log("vlaidated")
      const selectedQueryType = this.contactForm.value.contactFormQueryType;
      const subject = `Helpdesk Form - Beijing Institute Of Petrochemical Technology`;
      var query = this.contactForm.value.contactFormName + "||" + this.contactForm.value.contactFormMessage + "||" + this.contactForm.value.contactFormProductName + "||" + this.contactForm.value.contactFormInquiryType
      this.networkCall.postContactUs(this.contactForm.value.contactFormEmail, query,  this.router.url).subscribe(result => {
        this.formSection = false;
        this.thankSection = true;
        this.toastr.success("感谢您，我们会尽速和您联络")
        this.contactForm.reset();
      }, error => {
        // this.shareService.errorHandller(error);
      })
    } else {
      // this.toastr.warning("Please fill in the necessary details on the form.")
      this.validateAllFormFields(this.contactForm);
    }
    // const allInfo = `My name is ${this.name}. My email is ${this.email}. My message is ${this.message}`;
    // alert(allInfo);
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

}
